// 在进入课程详情页面的时候，判断用户id，如果在白名单，则播放mp4的课程视频地址

export const whiteList = [
  "554961416228384780"
  // "556990622995546112" // 测试账号 18800000001
];
export const isWhiteList = function(userId) {
  if (whiteList.indexOf(userId) !== -1) {
    return true;
  }
  return false;
};
